import { AuthorizationService } from './authorization/authorization.service';
import { AuthenticationGuard } from './authentication/authentication.guard';
import { ToastModule } from './toast/toast.module';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { BaseLayoutComponent } from './layout/base-layout/base-layout.component';
import { AuthenticatedLayoutComponent } from './layout/authenticated-layout/authenticated-layout.component';
import { LoginComponent } from './authentication/login/login.component';
import { GlobalErrorHandlerService } from './telemetry/global-error-handler.service';
import { LoggerService } from './telemetry/logger.service';
import { AuthenticationService } from './authentication/authentication.service';
import { LogoutComponent } from './authentication/logout/logout.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { TitleService } from './layout/title.service';
import { TitleBarComponent } from './layout/title-bar/title-bar.component';
import { AuthenticationInterceptor } from './authentication/authentication.interceptor';
import { HttpRequestLoggingInterceptor } from './telemetry/http-request-logging.interceptor';
import { SharedModule } from './common/shared.module';
import { DialogModule } from './dialog/dialog.module';
import { ValidationErrorModule } from './validation-error/validation-error.module';
import { AuthorizeComponent } from './authorization/authorize/authorize.component';
import { PageToolbarComponent } from './layout/page-toolbar/page-toolbar.component';
import { UserStateService } from './user-state/user-state.service';
import { AuthorizationGuard } from './authorization/authorization.guard';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MenuToolbarComponent } from './layout/menu-toolbar/menu-toolbar.component';
import { FormBoxModule } from './common/form-box/form-box.module';
import { NetworkConnectivityComponent } from './layout/network-connectivity/network-connectivity.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NavigationLandingComponent } from './authorization/navigation-landing/navigation-landing.component';
import { SharedInputModule } from './common/shared.input.module';
import { NotificationBadgeModule } from './notification-badge/notification-badge.module';
import { InstallPromptComponent } from './authentication/login/install-prompt/install-prompt.component';
import { ActionButtonModule } from "./common/action-button/action-button.module";
import { VersionUpdateService } from './versioning/version-update-service';
import { VersionUpgradeComponent } from './layout/version-upgrade/version-upgrade.component';
import { MenuItemsComponent } from './layout/menu-toolbar/menu-items/menu-items.component';
import { NavbarLinkComponent } from './layout/menu-toolbar/navbar-link/navbar-link.component';
import { VersioningInterceptor } from './versioning/versioning.interceptor';
import { ServerConnectionIndicatorComponent } from './layout/server-request/server-connection-indicator.component';
import { SchemaValidationService } from './schema/validation-service/schema-validation-service';
import { SyncDataInterceptor } from './driver/services/data/sync-data.interceptor';
import { CompleteBinaryDataSyncInterceptor } from './driver/services/data/complete-binary-data-sync.interceptor';
import { BackgroundOperationsDrawerComponent } from './layout/title-bar/background-operations/background-operations-drawer.component';
import { UserMenuComponent } from './layout/title-bar/user-menu/user-menu.component';

/**
 * This is the main module for the app.
 */
@NgModule({
	declarations: [
		AppComponent,
		BaseLayoutComponent,
		AuthenticatedLayoutComponent,
		LoginComponent,
		InstallPromptComponent,
		TitleBarComponent,
		LogoutComponent,
		PageNotFoundComponent,
		AuthorizeComponent,
		NavigationLandingComponent,
		PageToolbarComponent,
		MenuToolbarComponent,
		NetworkConnectivityComponent,
		VersionUpgradeComponent,
		ServerConnectionIndicatorComponent,
		MenuItemsComponent,
		NavbarLinkComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		SharedInputModule,
		FormsModule,
		HttpClientModule,
		NotificationBadgeModule,
		RouterModule,
		SharedModule,
		DialogModule,
		ValidationErrorModule,
		ToastModule,
		BrowserAnimationsModule,
		FormBoxModule,
		ActionButtonModule,
		UserMenuComponent,
		BackgroundOperationsDrawerComponent,
		ServiceWorkerModule.register('crown-service-worker.js', {
			registrationStrategy: 'registerImmediately',
			enabled: true,
			scope: '/'
		})
	],
	providers: [
		{ provide: ErrorHandler, useClass: GlobalErrorHandlerService },
		{ provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: HttpRequestLoggingInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: VersioningInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: SyncDataInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: CompleteBinaryDataSyncInterceptor, multi: true },
		LoggerService,
		AuthenticationService,
		TitleService,
		AuthorizationService,
		AuthenticationGuard,
		AuthorizationGuard,
		HttpClient,
		UserStateService,
		VersionUpdateService,
		SchemaValidationService
	],
	bootstrap: [ AppComponent ]
})
export class AppModule {
	constructor(schemaValidationService: SchemaValidationService) {
		schemaValidationService.ValidateModels();
	}
}